import {Component, Inject, OnInit} from "@angular/core";
import {TableControllerService} from "../../../services/table-controller.service";
import {FilterControllerService} from "../../../services/filter-controller.service";
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {ActionSet, Data} from "../../../models/layout";
import {_Data, _DetailPageLayoutSection, _ResponseDetailLayout, LayoutServiceService} from "../../../services/layout.service";
import { MatDialogRef } from '@angular/material/dialog';



@Component({
	selector: "detail-page",
	templateUrl: "./detail-page.component.html",
	styleUrls: ["./detail-page.component.scss"],
	host: {'class': 'h-100'},
	providers: [TableControllerService, FilterControllerService]
})
export class DetailPageComponent implements OnInit
{
	// main page
	pageId: string;
	// inherit permission from main page
	actionSet?: ActionSet;
	// id of the object to display (oem work with string ids)
	id: string;
	// sections to display
	sections?: _DetailPageLayoutSection[];
	// default apiParent is 'detail'
	apiParent: string = 'detail';
	// true il the detail page is loading the layout information, false when loading ends
	isLoading: boolean = true;
	// become true if an error occurred while loading the detail page
	errorOccurred: boolean = false;
	// expand and reduce page size
	isFullscreen = false;

	constructor(
		public layoutService: LayoutServiceService,
		private dialogRef: MatDialogRef<DetailPageComponent>,
		// retrieve dialog input values
		@Inject(MAT_DIALOG_DATA) public data: any
	)
	{
		this.pageId = this.data['pageId'];
		this.id = this.data['id'];
		this.actionSet = this.data['actionSet'];
	}


	/**
	 * ngOnInit load the layout information
	 */
	async ngOnInit()
	{
		console.info(`Loading page layout for ${this.pageId}`);
		await this.getPageLayout();
		console.info(`End of loading page layout for ${this.pageId}`);
	}

	private async getPageLayout(): Promise<void>
	{
		try
		{
			if (!this.pageId)
			{
				console.error("Error: pageId undefined!");
				this.errorOccurred = true;
				return;
			}

			const res: _ResponseDetailLayout | null = await this.layoutService.getDetailPageLayout(this.pageId);

			// invalid response or response code
			if (!res || res.iResponseCode !== 200)
			{
				console.error("Error: Invalid response or bad status code", res);
				this.errorOccurred = true;
				return;
			}

			// invalid content
			if (!res.oContent || !Array.isArray(res.oContent.detailSections))
			{
				console.error("Error: detailSections missing or invalid", res);
				this.errorOccurred = true;
				return;
			}

			// Sort sections by type (Forms first)
			this.sections = res.oContent.detailSections.sort((a, b) =>
			{
				return a.layoutSectionId === 'LYO_DETAIL_SECFORM' ? -1 : b.layoutSectionId === 'LYO_DETAIL_SECFORM' ? 1 : 0;
			});

		}
		catch (error)
		{
			this.errorOccurred = true;
			console.error("Error while retrieving layout:", error);
		}
		finally
		{
			this.isLoading = false;
		}
	}

	// convert _Data[] list to Data[]
	convertsDatasetData(datas: _Data[]): Data[]
	{
		if (datas == null || datas.length == 0)
		{
			return [];
		}
		const convertedDatas: Data[] = [];
		let _data: _Data;
		for (let i = 0; i < datas.length; i++)
		{
			_data = datas[i];
			convertedDatas.push(
				{
					optionValues: [],
					id: _data.dataId,
					type: _data.dataType,
					columnName: _data.columnName,
					columnLabel: _data.columnLabel,
					columnPosition: _data.columnPosition,
					editable: _data.isEditable,
					selectOptions: [],
					isPk: _data.isPk,
					valuesFrom: '', // not handled
					radioGroup: _data.radioGroup ?? [],
					isRequiredField: _data.requiredField ?? false,
					maxLength: _data.maxLength ?? null,
					patternInfo: _data.patternInfo ?? null,
					regExpList: _data.regexpList ? JSON.parse(_data.regexpList) : [],
					fixListValues: '', // not handled
					sortOrder: _data.sortOrder,
					sortCriteria: _data.sortCriteria,
					isResultsetLinked: _data.isResultsetLinked,
					isVisible: !_data.isHidden
				}
			);
		}
		return convertedDatas;
	}

	toggleFullscreen() {
		this.isFullscreen = !this.isFullscreen;

		if (this.isFullscreen) {
			this.dialogRef.updateSize('100vw', '100vh', ); // fullscreen mode
		} else {
			this.dialogRef.updateSize('65vw', '80vh'); // same sizes defined on the open dialog in data-table component
		}

		// remove max and min size
		const dialogContainer = document.querySelector('.mat-dialog-container') as HTMLElement;
		if (dialogContainer) {
			if (this.isFullscreen) {
				dialogContainer.style.maxWidth = '100vw';
			} else {
				dialogContainer.style.maxWidth = '';
			}
		}
	}

	// close the dialog page
	closeDialog(): void {
		this.dialogRef.close();
	}

}
